import jQuery from 'jquery';
let $ = jQuery;

import "./Widget.js";

/**
    * class HSN.Widget.AddEditPayment
    *
    * Encapsulates the common functionality of the AddEditPayment Widget.
    **/
HSN.Widget.AddEditPayment = function () {
    var application;
    var container;
    var scope = this;
    var isEdit;
    var tokenizationUrl;
    var paymentService;
    var deviceInformation;
    var isTokenizerOk = false;
    /**
        * new HSN.Widget.AddEditPayment.init(config)
        * - config (Object): A configuration object for the [[HSN.Widget.AddEditPayment]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the widget.
        **/
    function init(config) {
        application = config.application;
        container = $(config.container);
        isEdit = (config.isEdit || false);
        tokenizationUrl = config.tokenizationUrl;
        paymentService = application._getPaymentService();
        deviceInformation = application.DeviceInformation;
        bindEvents();
    }

    function bindEvents() {
        if (!isEdit) {
            let easyXdmPromise = import(/* webpackChunkName: "easyXDM" */ 'LIBS/easyXDM.js');

            easyXdmPromise
                .then(EasyXDMLoaded => {
                    $('#card-number').hide();
                    application.ccTokenizerSocket = new easyXDM.Rpc({
                            remote: tokenizationUrl,
                            props: {
                                id: 'card-number_Tokenizer',
                                frameborder: 0,
                                scrolling: 'no',
                                style: {
                                    overflow: 'hidden',
                                    width: '100%',
                                    height: '34px',
                                    allowTransparency: 'true',
                                    margin: '5px auto'
                                }
                            },
                            container: $('#card-number-container')[0]
                        },
                        {
                            remote: {
                                tokenize: {},
                                clearTextBox: {},
                                status: {}
                            }
                        });

                    window.setTimeout(function() {
                            application.ccTokenizerSocket.status(function() {
                                isTokenizerOk = true;
                            });
                        },
                        4800);
                    window.setTimeout(function() {
                            if (!isTokenizerOk) {
                                paymentService.LogTokenizerFailure({ Type: 'CreditCard' }, {});
                            }
                        },
                        5000);
                });
        }

        container.on('click', '#make-default, #is-debit, #save-flag', function () {
            $(this).val(this.checked);
        });
        container.on('click', '#cancel', function () {
            application.Events.Trigger(HSN.Widget.AddEditPayment.EVENT.CANCELED, isEdit);
            return false;
        });
        container.on('click', '#save-add, #save-edit', function () {
            var form = $('#payment-form');
            if (!isEdit && $('#card-number').length && (!$('#credit-card').length || $('#credit-card').hasClass('active')) && application.ccTokenizerSocket) {
                application.ccTokenizerSocket.tokenize(function (response) {
                    isTokenizerOk = true;
                    if (response.error) {
                        var respError = { "errorFields": [{ "Key": 'CardNumber', "Value": response.error.faultDetail }], "errors": [response.error.faultDetail], "success": false }
                        HSN.AddErrorTreatment('#payment-form', respError, scope._container);
                        HSN.RemoveWait();
                        application.Events.Trigger(HSN.Widget.AddEditPayment.EVENT.SAVE_FAILED, respError);
                    }
                    else {
                        $('#CCTokenizationToken').val(response.data.token);
                        $('#CCTokenizationCardType').val(response.data.cardType);
                        $('#CCTokenizationBankName').val(response.data.bankName);
                        SavePaymentInformation(form);
                        return false;
                    }
                    return false;
                });
            }
            else {
                SavePaymentInformation(form);
                return false;
            }
            return false;
        });
        application.Events.On(HSN.Widget.AddEditPayment.EVENT.TOKENIZE_CARD, TokenizeCard);
    }
    function TokenizeCard(callback) {
        if(!isEdit && $('#card-number').length && (!$('#credit-card').length || $('#credit-card').hasClass('active')) && application.ccTokenizerSocket) {
            application.ccTokenizerSocket.tokenize(function(response) {
                isTokenizerOk = true;
                if(response.error) {
                    var respError = { "errorFields" : [{ "Key" : 'CardNumber', "Value" : response.error.faultDetail }], "errors" : [response.error.faultDetail], "success" : false }
                    application.Events.Trigger(HSN.Widget.AddEditPayment.EVENT.SAVE_FAILED, respError);
                }
                else {
                    $('#CCTokenizationToken').val(response.data.token);
                    $('#CCTokenizationCardType').val(response.data.cardType);
                    $('#CCTokenizationBankName').val(response.data.bankName);
                    callback();
                    return false;
                }
                return false;
            });
        }
        else {
            callback();
        }
    }
    function SavePaymentInformation(form) {
        var isSaved = $('#save-flag', container).val() === 'true';
        var isAdd = form.find('input[name=Type]').val() === 'add';
        var isMakeDefault = $('#make-default', container).val() === 'true';

        paymentService.ValidatePayment(form.serialize(), {
            callback: function (data) {
                if (data.success) {
                    HSN.SetWait();
                    paymentService.AddEditPaymentSave(form.serialize(), {
                        callback: function (respData) {
                            if (respData.success) {
                                respData.isSaved = isSaved;
                                respData.isAdd = isAdd;
                                respData.isMakeDefault = isMakeDefault;
                                application.Events.Trigger(HSN.Widget.AddEditPayment.EVENT.SAVE_COMPLETE, respData);
                            } else if (respData.mergeErrorDestination) {
                                window.location.href = respData.mergeErrorDestination;
                            } else if (respData.errorFields) {
                                HSN.AddErrorTreatment('#payment-form', respData, container);
                                application.Events.Trigger(HSN.Widget.AddEditPayment.EVENT.SAVE_FAILED, respData);
                            } else {
                                HSN.CheckoutHandleError(container, respData, 'Unfortunately there was an error attempting to save your payment method, please try again.');
                                application.Events.Trigger(HSN.Widget.AddEditPayment.EVENT.SAVE_FAILED, respData);
                            }
                        },
                        scope: this
                    });
                } else {
                    if (data.errorFields) {
                        HSN.AddErrorTreatment('#payment-form', data, container);
                        application.Events.Trigger(HSN.Widget.AddEditPayment.EVENT.SAVE_FAILED, data);
                    } else {
                        HSN.CheckoutHandleError(container, data, 'Unfortunately there was an error attempting to save your payment method, please try again.');
                        application.Events.Trigger(HSN.Widget.AddEditPayment.EVENT.SAVE_FAILED, data);
                    }
                }
                HSN.RemoveWait();
            },
            scope: this
        });
    }
    function Destroy() {
        if (application) {
            application.Events.Off(HSN.Widget.AddEditPayment.EVENT.TOKENIZE_CARD, null, this);
        }
        application = container = paymentService = deviceInformation = null;
    }
    return {
        init: init,
        Destroy: Destroy
    }
};

HSN.Widget.AddEditPayment.EVENT = {
    CANCELED: 'HSN.Widget.AddEditPayment:CANCELED',
    SAVE_COMPLETE: 'HSN.Widget.AddEditPayment:SAVE_COMPLETE',
    SAVE_FAILED: 'HSN.Widget.AddEditPayment:SAVE_FAILED',
    TOKENIZE_CARD: 'HSN.Widget.AddEditPayment:TOKENIZE_CARD'
};



// WEBPACK FOOTER //
// ./assets/js/HSN/Widget/AddEditPayment.js